<div class="maintenance-container">
    <div class="maintenance-banner">
        <div class="maintenance-content">
            <div class="maintenance-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                    <path d="M12 9v4" />
                    <path d="m12 17 .01 0" />
                </svg>
            </div>
            <div class="maintenance-text">
                <h3 class="maintenance-title">No Products Available</h3>
                <p class="maintenance-description">
                    You do not currently have access to any product. Please contact your system administrator or
                    <a href="mailto:support@lakehouse-analytics.com" target="blank">LakeHouse Support</a> for more
                    information.
                </p>
            </div>
        </div>
    </div>
</div>